import { render } from "./Index.vue?vue&type=template&id=65d5e97e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=65d5e97e&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-65d5e97e"

export default script